import {TFunction} from "i18next";

export const routes = (t: (route: string) => string): any => {
  return {
    root: '/',
    session: {
      login: '/login',
      authentication: '/auth',
      oauth: `https://idpdecathlon.oxylane.com/as/authorization.oauth2?client_id=${process.env.REACT_APP_CLIENT_ID}&response_type=code&redirect_uri=${process.env.REACT_APP_API_URL}v1/auth/sso&scope=openid%20profile%20email`,
    },
    users: t('userRoute'),
    alliances: t('allianceRoute'),
    catalog: {
      root: t('catalogRoute'),
      detail: `${t('catalogDetailRoute')}/:supermodel`,
    },
    stores: t('storesRoute'),
    categories: t('categoriesRoute'),
    orders: {
      root: t('ordersRoute'),
      orders: t('orderDetailRoute'),
      payments: t('orderPaymentsRoute'),
      shipments: t('orderShipmentsRoute'),
    },
  };
};
